import styled from "styled-components";
import { V3Button } from "../Button";

export const UserThemableButton = styled(V3Button)`
    background: ${({ theme }) => theme.customization.accentcolour};
    border: 1px solid ${({ theme }) => theme.customization.accentcolour};
`;
